import { render, staticRenderFns } from "./RankingManagement.vue?vue&type=template&id=d276581a"
import script from "./RankingManagement.vue?vue&type=script&lang=js"
export * from "./RankingManagement.vue?vue&type=script&lang=js"
import style0 from "./RankingManagement.vue?vue&type=style&index=0&id=d276581a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports